<template>
    <v-container fluid dark flat>
        <div class="overlay-loading" v-if="!transportFound">
            <h3 style="color: #9D4593">{{mensajeInicial}}</h3>
        </div>
        <v-toolbar
      app
      color="white"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Demosle Logo"
          class="mr-2"
          contain
          :src="require('../../../assets/static/img/logo-demosle.png')"
          transition="scale-transition"
          width="150"
          
        />
      </div>
      <v-spacer></v-spacer>
    </v-toolbar>
        <v-layout row wrap class="inner-container" justify-center mx-auto>
            <v-container px-0 py-3 flat>
                <v-stepper v-model="e1">
                    <v-stepper-header style="display:none">
                        <v-stepper-step 
							:complete="e1 > 1"
							step="1" 
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Nombre
                        </v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 2"
							step="2"
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Elementos</v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 3"
							step="3"
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Direcciones</v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 4"
							step="4"
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Precios</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-content step="1">
                        <!-- Nombre -->
                        <First/>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <!-- Elementos -->
                        <Second/>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <Third/>     
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <Fourth/>
                    </v-stepper-content>
                </v-stepper>
            </v-container>
        </v-layout>
        <v-layout row justify-center></v-layout>
    </v-container>
</template>
<script>
import LoadingLogo from '../../../helpers/LoadingLogo'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import axios from 'axios'
import cryptoJS from 'crypto-js'
import * as distance from 'google-distance-matrix'
import { EventBus } from '../../../events.js'
import First from './Grande/First'
import Second from './Grande/Second'
import Third from './Grande/Third'
import Fourth from './Grande/Fourth'

export default {
    title: 'Cotización ',
    components: {
        LoadingLogo,
        First,
        Second,
        Third,
        Fourth
    },
    data () {
        return {
            phoneLength: 9,
            codigoDefault: '+56',
            codigos: ['+56', '+51','+54','+55', '+56','+57','+58','+1','+591','+593','+595','+598'],
            loadingPedido: false,
            e1: 1,
            rules: {
                nameRules: [
                    v => !!v || 'Campo obligatorio'
                ],
                emailRules: [
						v => !!v || 'Campo obligatorio',
						v => {
							const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
							if(re.test(v)){
								return true
							}
							return 'Verifica que el email sea válido'
						}
					]
            },
            stepValidation: {
                first: false,
                second: false,
                third: false,
                fourth: false
            },
            datos: {
                first: {},
                second: {},
                third: {},
                baseValue: 0
            },
            tryChange: {
                first: false,
                second: false,
                third: false,
                fourth: false
            },
            pedidoID: '',
            controlSavedPedido: false,
            dialogPago: false,
            menu: false,
            today: new Date().toISOString().substr(0, 10),
            mantenedores: {},
            horas: ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45'],
            typeTooltip: 'warning',
            showTooltip: false,
            proceedTributary: false,
            documentoTributario: '',
            boleta: {
                nombre:'',
                rut: ''
            },
            factura: {
                rut:'',
                razonSocial: '',
                giroComercial: '',
                direccion: '',
                comuna: '',
                ciudad: '',
                telefono: ''
            },
            proceedPayment: false,
            selectedPayment: 1,
            ofertaActiva: false,
            paymentValue: 0,
            abonoMessage: '',
            toPayValue: 0,
            loadingPay: false,
            dialogPagoCompleto: false,
            paymentInfo: {
                id: '',
                monto: 0,
                fecha: '',
                forma_pago: ''
            },
            
            datetimeOK: true,
            dataPersonal: {
                nombre: '',
                apellido: '',
                nombreCompleto: '',
                email: '',
                telefono: '',
            },
            dialogDatosPersonalesE: false,
            tomorrow: '',
            dialogPersonalesValidate: false,
            nsPedido: null,
            tipoServicio: 0,
            fromDemo: true,
            transportFound: false,
            mensajeInicial: 'Estamos cargando la información para crear el pedido.'
        }
    },
    methods: {
        goAfterPersonalDataE() {
            this.dataPersonal.nombreCompleto =  this.datos.first.personales.nombre + ' ' + this.dataPersonal.apellido
            const data = {
                usuario: {
					nombre: this.dataPersonal.nombreCompleto,
					email: this.dataPersonal.email,
					telefono: this.dataPersonal.telefono,
                    nombrePila: this.datos.first.personales.nombre,
                    apellido: this.dataPersonal.apellido
				}
			}
			const db = firebase.firestore()
			db.collection('pedidos').doc(this.pedidoID).update(data)
            this.dialogPago = true
            this.dialogDatosPersonalesE = false
        },
        tributario(documento){
            this.documentoTributario = documento
        },
        proceedDialog(type, tipo){
            if (type === 1) {
                this.proceedTributary === false ? this.proceedTributary = true : this.proceedTributary = false
                this.dialogPago === false ? this.dialogPago = true : this.dialogPago = false
            } else if (type === 2) {
                this.proceedTributary === false ? this.proceedTributary = true : this.proceedTributary = false
                this.proceedPayment === false ? this.proceedPayment = true : this.proceedPayment = false
            }
            this.eventTracker(tipo)
        },
        eventTracker(tipo) {
            gtag('event', tipo, {
            'event_category' : tipo,
            'event_label' : tipo
            })
        },
        async goToPay(valor, idPedido, paymentMethod, tipo){
            const here = this
            this.eventTracker(tipo)
            /* if(this.time_diff >= 0) { */
                this.colorTooltipActivator = '#1f97b9'
                this.loadingPay = true
                let db = firebase.firestore()
                if (here.documentoTributario == 'Factura') {
                    const documento_tributario = {
                        documento_tributario: {
                            documento: here.documentoTributario,
                            factura: here.factura
                        }
                        
                    }
                    await db.collection('pedidos').doc(idPedido).update(documento_tributario)
                } else if (here.documentoTributario == 'Boleta') {
                    const documento_tributario = {
                        documento_tributario: {
                            documento: here.documentoTributario,
                            boleta: here.boleta
                        }
                    }
                    await db.collection('pedidos').doc(idPedido).update(documento_tributario)
                }
                db.collection("pagos").add({
                    id_pedido: idPedido,
                    monto: valor,
                    estado: 'Esperando Pago',
                    fecha_ingreso: firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(function(docRef) {
                        here.payFlow(valor, docRef.id, idPedido, paymentMethod)
                })
                .catch(error => {
                    here.loadingPay = false
                })
                const updatePedido = {
                    fecha: this.datos.first.date,
                    hora: this.datos.first.time
                }
                db.collection('pedidos').doc(idPedido).update(updatePedido)
            /* } else if(this.time_diff < 0){
                this.showTooltip = true
                this.colorTooltipActivator = 'red'
            } */
        },
        payFlow(valor, idPago, idPedido, paymentMethod){
            const here = this
            let flow_params = {
                amount: valor,
                apiKey: '58D1DFFC-908B-43E9-80D0-1LA6424AC4FD', //Producción
                // apiKey: '3C7F5DF0-1742-402A-975C-9F5D29FF5LC2', //Desarrollo
                commerceOrder: idPago,
                email: this.dataPersonal.email,
                /* optional: JSON.stringify({'idPedido': idPedido}), */
                optional: JSON.stringify({'idPedido': idPedido,'tipo': 1}),
                paymentMethod: paymentMethod,
                subject: 'Pago Transportes DUO: ' + idPedido,
                    urlConfirmation: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/verificarFlow', //Producción
                /* urlConfirmation: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/verificarFlowDev', */ //Desarrollo
                urlReturn: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/finalFlow'
            }
            let data = ''
            let signData = ''
            let cont = 0
            console.log("flow_params: ",flow_params)
            Object.keys(flow_params).forEach(function(key) {
                signData += '&' + key + '=' + flow_params[key]
                data += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(flow_params[key])
                cont++
                if(cont === 9){
                    signData = signData.substring(1)
                    data = data.substring(1)
                    here.signAndSend(signData)
                }
            });

        },
        signAndSend(signData){
            const here = this
            const signature = cryptoJS.HmacSHA256(signData, '83558e934b88eeab5293faa6cf9a4d19aae1b937') //Producción
            // const signature = cryptoJS.HmacSHA256(signData, '66c129032423c9e8fa06e0627fbf1be0c0ef8276') //Desarrollo
            const payFlow = firebase.functions().httpsCallable('initFlow')
            axios({
                    method: 'post',
                    url: 'https://cors-anywhere.herokuapp.com/https://www.flow.cl/api/payment/create', //Producción
                    // url: 'https://cors-anywhere.herokuapp.com/https://sandbox.flow.cl/api/payment/create', //Desarrollo
                    /* url: 'https://cors-proxy.htmldriven.com/https://www.flow.cl/api/payment/create', */
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: signData + '&s=' + signature
                })
                .then(response => {
                    gtag('event', 'conversion', {
                        'send_to': 'AW-867600071/CSwpCLKi--0CEMeN2p0D',
                        'value': 1.0,
                        'currency': 'CLP',
                        'transaction_id': 'cotizacion'
                    });
                    window.location.href = response.data.url + "?token=" + response.data.token
                })
                .catch(error => {
                console.log("Error Flow: ", error)
                    here.loadingPay = false
                })

        },
        changeAbono(){
            this.abonoMessage = 'Saldo por pagar $' + Math.ceil(this.paymentValue - this.toPayValue).toLocaleString()
        },
        getDistanceMatrix(){
            return new Promise(async(resolve, reject) => {
                const here = this
                var service = new google.maps.DistanceMatrixService()
                await service.getDistanceMatrix(
                    {
                        origins: [this.datos.first.direccion_origen.direccion],
                        destinations: [this.datos.first.direccion_destino.direccion],
                        travelMode: 'DRIVING'
                    },
                    function (response, status) {
                        here.datos.first.distancia = response.rows[0].elements[0]
                        resolve(true)
                    }
                )
            })
        },
        setInitialHour(){
            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + 1)
            this.datos.first.date = tomorrow.toISOString().substr(0, 10)
            const date = this.$moment().add(this.mantenedores.tiempo_minimo/3600,'h').add(5,'m')
            let horas = date.hour()
            let minutos = date.minute()
            if(minutos == 0 || minutos == 15 || minutos == 30 || minutos == 45 ){}
            else if(minutos < 15){ minutos = 15 }
            else if(minutos < 30){ minutos = 30 }
            else if(minutos < 45){ minutos = 45 }
            else if(minutos < 60){
                if(minutos > 45){
                    minutos = 0
                    horas++
                    if(horas == 24){horas = 0}
                }
            }
            let h = horas.toString()
            let m = minutos.toString()
            if(horas < 10){ h = '0' + horas.toString() }
            if(minutos < 10){ m = '0' + minutos.toString() }
            this.datos.first.time = h + ':' + m
        },
        get_mantenedores(){
            let db = firebase.firestore()
            let self = this
            db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
                    if (doc.exists) {
                            self.mantenedores = doc.data()
                            self.setInitialHour()
                            //self.initHoursPicker()
                            EventBus.$emit('emmitMantenedoresDemo', self.mantenedores);
                    } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                    }
            }).catch(function(error) {
                    console.log("Error getting document:", error);
            });
        },
        validTimeDiff(){
            this.datetimeOK = true
            const now = this.$moment()
            let hour_selected = this.$moment(this.datos.first.date + ' ' + this.datos.first.time, this.$moment.defaultFormat)
            let hour_limit = this.$moment().add(this.mantenedores.tiempo_minimo, 'seconds')
            this.time_diff = hour_selected.diff(hour_limit, 'seconds')
            if (this.time_diff <= 0 && this.mantenedores){
                if(!this.mantenedores.tiempo_minimo){
                    return true
                }
                this.typeTooltip = 'danger'
                this.colorTooltipActivator = 'red'
                if(this.dialogPago){
                    this.showTooltip = true
                }
                else{
                    this.showTooltip = false
                }
                this.datetimeOK = false
                return false
            }
            else{
                this.colorTooltipActivator = '#1f97b9'
                this.typeTooltip = 'warning'
                return true
            }
        },
        async save_data(data){
            const here = this
            //Guarda información del pedido en la BD, en espera de pago (Para pedido básico y completo)
            let oferta = {
                glosa: '',
                monto: '',
                activo: false,
                campo: '',
                completo: ''
            }
            if (data.first && data.first.oferta && data.first.oferta.activo) {						
                oferta = data.first.oferta
            }
            let idCliente = this.$store.state.idCliente
            console.log('antes de establecer pedido')
            console.log(this.datos)
            const pedido = {
                usuario: data.first.personales,
                direcciones: {
                    origen: data.first.direccion_origen.direccion,
                    destino: data.first.direccion_destino.direccion
                },
                elementos: data.second,
                /* fecha: data.first.date, */
                fecha: this.datos.first.fecha,
                hora: this.datos.first.hora,
                /* hora: data.first.time, */
                fecha_servicio_obj: new Date(this.datos.first.fecha + 'T' + this.datos.first.hora),
                datosDireccion: {
                    origen: data.third.origen,
                    destino: data.third.destino
                },
                datoPagos: [],
                basicoValue: data.basicoValue,
                completoValue: data.completoValue,
                created: firebase.firestore.FieldValue.serverTimestamp(),
                estado: 'Cotización',
                servicio: data.servicio,
                paymentValue: 0,
                tipo: this.datos.tipo,
                distancia: this.datos.first.distancia,
                tiempos: {
                    distancia: Math.round(this.datos.first.distancia.duration.value/60),
                    carga: this.tiempoCarga(this.datos.second)
                },
                cargos: [],
                descuentos: [],
                registroOferta:[],
                clienteID: idCliente,
                backUpService: false,
                cotizacionExpress: false,
                fromDemo: true,
                oferta,
                demotrp: this.$route.query.id
            }
            console.log('aqui llega al guardar la data')
            if (this.dialogPersonalesValidate) {
                pedido.usuario.email = this.dataPersonal.email,
                pedido.usuario.telefono = this.dataPersonal.telefono
            }
            if (this.mantenedores.ajuste_mudanza > 0) {
                const valorAjusteBasico = pedido.basicoValue.amount * (1 - this.mantenedores.ajuste_mudanza)
                const valorAjusteCompleto = pedido.completoValue !== 0 ? pedido.completoValue.amount * (1 - this.mantenedores.ajuste_mudanza) : 0
                pedido.ajuste_mudanza = {
                    ajuste_porcentaje: this.mantenedores.ajuste_mudanza,
                    ajuste_valorBasico: Math.ceil(valorAjusteBasico / 1000) * 1000 - 10,
                    ajuste_valorCompleto: valorAjusteCompleto !== 0 ?  Math.ceil(valorAjusteCompleto / 1000) * 1000 - 10 : 0
                }
            }
            let db = firebase.firestore()
            
            if(here.pedidoID != ''){
                db.collection("pedidos").doc(here.pedidoID).set(pedido, {merge: true})
                    .then(function() {
                        const createNSpedido = firebase.functions().httpsCallable('createNSPedido')
                        createNSpedido({idPedido: here.pedidoID})
                            .then(function(result){
                                here.nsPedido = result
                            })
                            .catch(function(error){
                                console.log("createNSPedido error: ", error)
                                console.log('se cae cuando está creado')
                            })
                        EventBus.$emit('idPedidoDemo', {pedidoID: here.pedidoID})
                    })
                    .catch(function(error) {
                        console.error("Error writing document: ", error);
                    });
            }
            else{
                await db.collection("pedidos").add(pedido)
                    .then(function(docRef) {
                        here.pedidoID = docRef.id
                        const createNSpedido = firebase.functions().httpsCallable('createNSPedido')
                        createNSpedido({idPedido: here.pedidoID})
                            .then(function(result){
                                here.nsPedido = result
                            })
                            .catch(function(error){
                                console.log("createNSPedido error: ", error)
                                console.log('se cae cuando no está creado')
                            })
                        EventBus.$emit('idPedidoDemo', {pedidoID: here.pedidoID})
                    })
                    .catch(function(error){
                        console.error("Error writing document: ", error);
                    });
            // db.collection('system_info').doc('pedidos').update({
            //     qty_pedidos: firebase.firestore.FieldValue.increment(1)
            // })
            }
        },
        tiempoCarga(elementos){
            let volumen = 0
            elementos.forEach(function(item){
                volumen += item.metros * item.qty
            })
            return Math.round( (volumen * this.mantenedores.vol_tiempo) * 100 ) / 100
        },
        getTopayValue(data){
            if(data.type === 1 && data.finalDataSave){
                if(data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && !data.finalDataSave.first.oferta.completo && !data.finalDataSave.ajuste_mudanza){
                    this.paymentValue = data.finalDataSave.basicoValue.amount
                    return data.finalDataSave.basicoValue.amount - data.finalDataSave.first.oferta.monto
                } else if (data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && !data.finalDataSave.first.oferta.completo && data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorBasico
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorBasico - data.finalDataSave.first.oferta.monto
                }
                if (data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorBasico
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorBasico
                }
                this.paymentValue = data.finalDataSave.finalValue.amount
                return data.finalDataSave.basicoValue.amount
            }
            else if(data.type === 2){
                if(data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && data.finalDataSave.first.oferta.completo && !data.finalDataSave.ajuste_mudanza){
                    this.paymentValue = data.finalDataSave.finalValue.amount
                    return data.finalDataSave.finalValue.amount - data.finalDataSave.first.oferta.monto
                } else if (data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && data.finalDataSave.first.oferta.completo && data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto - data.finalDataSave.first.oferta.monto
                }
                if (data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto
                }
                this.paymentValue = data.finalDataSave.finalValue.amount
                return data.finalDataSave.finalValue.amount
            }
        },
        selectPayment(type, data){
            this.selectedPayment = type
            if(type === 1){ this.toPayValue = Math.ceil(this.paymentValue * 0.3) }
            else if(type === 2){ this.toPayValue = Math.ceil(this.paymentValue * 0.3)}
        },
        setNextDay() {
            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + 1)
            this.tomorrow = tomorrow.toISOString().substr(0, 10)
        },
        get_pedido(id){
				this.loadingPedido = true
				let db = firebase.firestore()
				let self = this
				db.collection("pedidos").doc(id).get().then(function(doc) {
						if (doc.exists) {
							EventBus.$emit('closeServiceQuestionDemo', false);
							self.pedidoID = id //lleva el id del documento en la bd
                            
							EventBus.$emit('idPedidoRetomarDemo', {pedidoID: self.pedidoID, retomarPedido: true, data: doc.data()})
							// Dejamos la data del pedido en la variable data y asignamos a esa data si se debe cambiar de paso en data.move (boolean)
							let data = doc.data()
							self.pedidoContinuado = doc.data()
                            self.nsPedido = data.NS
							data.move = self.$route.query.move && self.$route.query.move == 1
							data.continue = self.$route.query.continue && self.$route.query.continue == 1
							// Emitimos sólo una vez el retomarPedido
							if (!data.usuario.nombrePila || data.usuario.nombrePila) {
								const arrayApellido = data.usuario.nombre.split([' '], [2])
								const nombre = arrayApellido[0]
								let apellido = ' '
								if (arrayApellido[1] !== undefined) {
									apellido = arrayApellido[1]
								}
								data.usuario.nombrePila = nombre
								data.usuario.apellido = apellido
							}
							self.datos = {
								first:{
									personales: {
										nombre: data.usuario.nombre,
										telefono: data.usuario.telefono,
										email: data.usuario.email,
										apellido: data.usuario.apellido,
										nombrePila: data.usuario.nombrePila
									},
									date: data.fecha,
									time: data.hora,
									direccion_origen:{
										direccion: data.direcciones.origen
									},
									direccion_destino:{
										direccion: data.direcciones.destino
									},
									oferta: data.oferta,
                                    distancia: data.distancia
								},
								second: data.elementos,
								third: data.datosDireccion,
								tiempos: data.tiempos,
								baseValue: data.basicoValue,
                                finalValue: data.completoValue,
								fecha_servicio_obj: data.fecha_servicio_obj,
							}
                            if (data.ajuste_mudanza && data.ajuste_mudanza.ajuste_porcentaje && data.ajuste_mudanza.ajuste_porcentaje > 0) {
                                self.datos.ajuste_mudanza = data.ajuste_mudanza
                            }
                            EventBus.$emit('retomarPedidoFirstDemo', self.datos.first)
                            EventBus.$emit('retomarPedidoSecondDemo', self.datos.second)
                            EventBus.$emit('retomarPedidoThirdDemo', self.datos)
                            EventBus.$emit('retomarPedidoFourthDemo', self.datos)
                            self.loadingPedido = false
							// obtener datos tributarios
							if (data.documento_tributario) {
								if (data.documento_tributario === 'Boleta') {
									const datosTributarios = {
										documentoTributario: 'Boleta',
										boleta: {
											nombre: data.documento_tributario.boleta.nombre,
											rut: data.documento_tributario.boleta.rut
										}
									}
									data.datosTributarios = datosTributarios
								}
							}
						} else {
								// doc.data() will be undefined in this case
							console.log("No such document!");
						}
				}).catch(function(error) {
						console.log("Error getting document:", error);
						self.loadingPedido = false
				});

			},
            async get_transportista(dataId) {
                const here = this
                const db = firebase.firestore()
                await db.collection('users').where('idDemo', '==', dataId).get().then(function(querysnapshot) {
                    if (!querysnapshot.empty) {
                        here.transportFound = true
                        querysnapshot.forEach(function(trp) {
                            const data = trp.data()
                            data.id = trp.id
                            EventBus.$emit('transportFound', data)
                        })
                    } else {
                        here.transportFound = false
                        here.mensajeInicial = 'Link incorrecto, contactate con tu transportista e intenta nuevamente.'
                    }
                })
            }
    },
    mounted () {
        this.get_mantenedores()
        this.setNextDay()
        if(this.$route.query.id) {
            this.get_transportista(this.$route.query.id) 
        }
        else { 
            this.transportFound = false
            this.mensajeInicial = 'Link incorrecto, contactate con tu transportista e intenta nuevamente.'
        }
        console.log(this.fromDemo + ' esto es del demo')
        EventBus.$on('mudanzaFirstDemo', async data => {//ver este
            if (!data.directions) {
                /* console.log('eso si') */
                this.tryChange.first = true
                this.stepValidation.first = data.valid
                this.dataPersonal.nombre = data.datos.personales.nombre
                this.dataPersonal.apellido = data.datos.personales.apellido
                this.dataPersonal.nombrePila = data.datos.personales.nombre + ' ' + data.datos.personales.apellido
                EventBus.$emit('retomarPedidoFirstReadyDemo')
                if(data.valid){
                    this.datos.first = data.datos
                    if(data.move){
                        this.e1 = 2
                        this.tryChange.first = false
                        window.scrollTo(0,0)
                    }
                }
            }
        })
        EventBus.$on('avanzarRetomarDemo', data => {
            this.e1 = data.e1
        })
        EventBus.$on('retrocederDemo', async data => {
            this.e1 = data 
            window.scrollTo(0,0)
        })
        EventBus.$on('mudanzaSecondDemo', async data => {
            this.tryChange.second = true
            this.stepValidation.second = data.valid
            if(data.valid){
                this.datos.second = data.datos
                if(data.qty <= this.mantenedores.qty_mudanza){
                    this.datos.tipo = "Flete"
                }
                else{
                    this.datos.tipo = "Mudanza"
                }
                if(data.move){
                    this.e1 = 3
                    this.tryChange.second = false
                    window.scrollTo(0,0)
                    /* console.log(this.datos) */
                }
            }
        })
        EventBus.$on('mudanzaThirdDemo', async data => {
            this.tryChange.third = true
            this.stepValidation.third = data.valid
            if(data.valid){
                this.datos.third = data.datos
                this.datos.first.direccion_origen = this.datos.third.direccion_origen
                this.datos.first.direccion_destino = this.datos.third.direccion_destino
                console.log(data)
                this.datos.first.fecha = data.datos.first.date
                this.datos.first.hora = data.datos.first.time
                /* console.log('============')
                console.log(data) */
                this.datos.third.destino = data.datos.destino
                this.datos.third.origen = data.datos.origen
                this.datos.dialogPersonalesValidate = this.dialogPersonalesValidate
                if (this.dialogPersonalesValidate) {
                    this.datos.dataPersonal = {
                        email: this.dataPersonal.email,
                        telefono: this.dataPersonal.telefono
                    }
                }
                this.setInitialHour()
                await this.getDistanceMatrix()
                EventBus.$emit('enterMudanzaFourthDemo', this.datos)
                if(data.move){
                    this.e1 = 4
                    this.tryChange.third = false
                    window.scrollTo(0,0)
                    /* console.log(this.datos) */
                }
            }
        })
        EventBus.$on('goBackMudanzaDemo', data => {
            this.e1 = data - 1
            window.scrollTo(0,0)
        })
        EventBus.$on('finalValueDemo', data => {
            /* console.log(data) */
            console.log('finalValueDemo')
            console.log(data)
            this.save_data(data)
        })
        EventBus.$on('datosDialogPersonalesDemo', data => {//nuevo on
            this.dataPersonal.email = data.usuario.email
            this.dataPersonal.telefono = data.usuario.telefono
            /* console.log(this.dataPersonal) */
            this.dialogPersonalesValidate = true
        })
        EventBus.$on('goForwardFinalDemo', data => {
            console.log(data)
            this.e1 = data.move
        })
        EventBus.$on('reservaPedidoDemo',  async data => {
            this.save_data(data.finalDataSave)
            if (data.finalDataSave.first.oferta.activo == true) {
                this.ofertaActiva = true
                this.paymentValue = await this.getTopayValue(data)
            } else {
                await this.getTopayValue(data)
            }
            this.tipoServicio = data.type // 1 basico; 2 completo
            /* console.log('A reservar pedido')
            console.log(data) */
            if (data.documento_tributario) {
                /* console.log('Entra al documento Tributario') */
                if (data.documento_tributario === 'Boleta') {
                    self.documentoTributario = 'Boleta'
                    self.boleta.nombre = data.documento_tributario.boleta.nombre
                    self.boleta.rut = data.documento_tributario.boleta.rut
                }
            }
            /* console.log(this.paymentValue) */
            this.setInitialHour()
            //this.initHoursPicker()
            const here = this
            this.showTooltip = true
            setTimeout(function() {
                here.showTooltip = false
            }, 5000);
            this.dialogPago = true
            /* this.dialogDatosPersonalesE = true */
            this.selectPayment(1, data)
        })
    }
}
</script>